import styled from 'styled-components';

export const Title = styled.div`
  font-size: 20px;
  color: #262b31;
  font-weight: bold;
  margin-bottom: 18px;
`;

export const Content = styled.div`
  white-space: normal;
  display: flex;
  flex-direction: column;

  &.danger,
  &.error,
  &.warning {
    background: url('/images/exclamation.svg') no-repeat 0 0;
    background-size: 50px;
    padding-left: 65px;
    padding-top: 12px;;
  }
`;

export const WarningText = styled.p`
  font-size: 15px;
  color: #000;
  margin-bottom: 25px;
  line-height: 1.2;
`;
